/* Offre quantité de la fiche cocooning — réplique du bloc Kaching d'Avenzo.
   La mécanique (lignes multiples, ajout au panier, tiroir) vient du kit ;
   seul l'affichage a été refait pour coller à la page d'origine. */
(function () {
  var LOT = document.querySelector('[data-cz-lot]');
  if (!LOT) return;
  /* Adresse de départ dans la langue de la page : « / » en français, « /it/ » en italien, « /es/ » en espagnol.
     Sans elle, le panier d'une page traduite répondait en français (12/10/2026). */
  var RACINE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var donnees = { options: [], variantes: [], pastilles: {} };
  try { donnees = JSON.parse(LOT.querySelector('[data-cz-donnees]').textContent); } catch (e) {}
  var variantes = donnees.variantes || [];
  var options   = donnees.options || [];
  var pastilles = donnees.pastilles || {};
  var vignettes = donnees.vignettes || [];   /* 09/10/2026 : une par couleur, dans l'ordre des valeurs du menu */
  var devise = LOT.getAttribute('data-devise') || '€';
  var apres  = LOT.getAttribute('data-devise-apres') === '1';
  var vignette = LOT.getAttribute('data-vignette') || '';
  var base   = parseInt(LOT.getAttribute('data-prix'), 10) || 0;
  var plein1 = parseInt(LOT.getAttribute('data-prix-barre'), 10) || base;
  var alerte = LOT.querySelector('.cz-lot__epuise');
  var bilan  = LOT.querySelector('.cz-lot__bilan');
  var bilanV = LOT.querySelector('[data-cz-bilan]');

  /* Devise du client : en euro rien ne change ; dans une autre devise (francs suisses…),
     format de la devise et remises converties au taux de Shopify, comme au paiement. */
  var deviseClient = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var taux = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
  function sous(c) {
    if (deviseClient !== 'EUR') {
      try { return new Intl.NumberFormat('fr-CH', { style: 'currency', currency: deviseClient }).format(c / 100); } catch (e) {}
    }
    var v = (c / 100).toFixed(2).replace('.', ',');
    return apres ? v + ' ' + devise : devise + v;
  }
  function coche() { return LOT.querySelector('input[name="cz-lot"]:checked'); }
  function quantite() { var c = coche(); return c ? parseInt(c.value, 10) : 1; }

  function echapper(t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }

  /* ── une ligne par article, dans chaque palier ─────────────────────────── */
  function dessiner() {
    [].forEach.call(LOT.querySelectorAll('.cz-lot__choix'), function (c) {
      var hote = c.querySelector('[data-cz-articles]');
      if (!hote || hote.childElementCount) return;          // déjà dessiné
      var n = parseInt(c.querySelector('input').value, 10);
      var offerts = parseInt(c.getAttribute('data-offerts'), 10) || 0;
      if (!options.length) return;
      /* relevé Venaro 19/09 : une ligne « Couleur, taille » 12/400 gris, puis « #1 [Couleur] [Taille] »
         (numéro 12/400, menus 34 px de haut, rayon 3.5) — pas de vignette, pas d'étiquette par menu */
      var proprietes = donnees.proprietes || [];
      var noms = options.concat(proprietes).map(function (o, k) { return k ? o.nom.toLowerCase() : o.nom; }).join(', ');
      var entete = document.createElement('span');
      entete.className = 'cz-lot__noms'; entete.textContent = noms; hote.appendChild(entete);
      /* 19/10/2026 : lien « Guide des tailles » à droite de la ligne, s'il y a la fenêtre du guide sur la page */
      if (donnees.guide && document.querySelector('[data-cz-guide]')) {
        var lien = document.createElement('button');
        lien.type = 'button'; lien.className = 'cz-lot__guide'; lien.setAttribute('data-cz-guide-ouvrir', '');
        lien.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 17 17 3l4 4L7 21z"/><path d="m7 13 2 2M10 10l2 2M13 7l2 2"/></svg><span>' + echapper(donnees.guide) + '</span>';
        entete.appendChild(lien);
      }
      for (var i = 0; i < n; i++) {
        var ligne = document.createElement('span');
        ligne.className = 'cz-lot__article';
        var html = '<span class="cz-lot__num">#' + (i + 1) + '</span><span class="cz-lot__menus">';
        for (var o = 0; o < options.length; o++) {
          var avecVignette = o === 0 && vignettes.length > 0;   /* le 1er menu est la couleur (seule vraie option) */
          /* 10/10/2026 : le menu Couleur est fait maison, pour montrer la vignette à gauche de CHAQUE couleur dans la
             liste ouverte (le menu du téléphone ne sait pas afficher d'image). Le vrai <select> reste dans la page,
             caché : c'est toujours lui que lit l'ajout au panier. */
          if (avecVignette) {
            var nomMenu = echapper(options[o].nom), nomsCouleurs = '', rangees = '';
            for (var rg = 0; rg < options[o].valeurs.length; rg++) {
              var coul = echapper(options[o].valeurs[rg]);
              nomsCouleurs += '<span>' + coul + '</span>';
              rangees += '<button type="button" class="cz-lot__couleur-choix" role="option" aria-selected="false" data-rang="' + rg + '">'
                + (vignettes[rg]
                    ? '<img class="cz-lot__couleur-image" src="' + vignettes[rg] + '" alt="" width="32" height="32">'
                    : '<span class="cz-lot__couleur-image" style="background:' + (pastilles[options[o].valeurs[rg]] || '#EEE') + '"></span>')
                + '<span class="cz-lot__couleur-nom">' + coul + '</span><span class="cz-lot__couleur-coche" aria-hidden="true"></span></button>';
            }
            html += '<span class="cz-lot__couleur">'
              + '<button type="button" class="cz-lot__couleur-bouton" aria-haspopup="listbox" aria-expanded="false" aria-label="' + nomMenu + '">'
              + '<img class="cz-lot__vignette" src="' + vignettes[0] + '" alt="" width="22" height="22">'
              + '<span class="cz-lot__couleur-noms">' + nomsCouleurs + '</span></button>'
              + '<span class="cz-lot__couleur-liste" role="listbox" aria-label="' + nomMenu + '" hidden>' + rangees + '</span>';
          }
          html += '<select data-option="' + o + '" aria-label="' + echapper(options[o].nom) + '"' + (avecVignette ? ' hidden tabindex="-1"' : '') + '>';
          for (var v = 0; v < options[o].valeurs.length; v++) {
            var val = options[o].valeurs[v];
            html += '<option value="' + val.replace(/"/g, '&quot;') + '">' + val + '</option>';
          }
          html += '</select>';
          if (avecVignette) html += '</span>';
        }
        for (var q = 0; q < proprietes.length; q++) {
          html += '<select data-propriete="' + echapper(proprietes[q].nom) + '" aria-label="' + echapper(proprietes[q].nom) + '">';
          var parDefaut = parseInt(proprietes[q].defaut, 10) || 0;   /* 19/10/2026 : taille choisie au départ (réglage) */
          for (var w = 0; w < proprietes[q].valeurs.length; w++) {
            var val2 = proprietes[q].valeurs[w];
            html += '<option value="' + val2.replace(/"/g, '&quot;') + '"' + (w === parDefaut ? ' selected' : '') + '>' + echapper(val2) + '</option>';
          }
          html += '</select>';
        }
        html += '</span>';
        ligne.innerHTML = html;
        hote.appendChild(ligne);
      }
    });
  }

  function trouver(choix) {
    for (var i = 0; i < variantes.length; i++) {
      var ok = true;
      for (var o = 0; o < choix.length; o++) if (variantes[i].options[o] !== choix[o]) { ok = false; break; }
      if (ok) return variantes[i];
    }
    return null;
  }

  function lignes(formule) {
    var c = coche(); if (!c) return [];
    var n = parseInt(c.value, 10);
    var hote = c.closest('.cz-lot__choix').querySelector('[data-cz-articles]');
    if (!options.length || !hote || !hote.querySelector('.cz-lot__article')) {
      var champ = formule && formule.querySelector('[name="id"]');
      var id = champ ? champ.value : (variantes[0] && variantes[0].id);
      return id ? [{ id: Number(id), quantity: n }] : [];
    }
    var sortie = [], manquant = false;
    [].forEach.call(hote.querySelectorAll('.cz-lot__article'), function (l) {
      /* les menus de variante (couleur) choisissent l'article ; ceux marqués data-propriete
         (la taille) ne sont qu'une note sur la ligne de commande : le produit est en taille unique */
      var choix = [].map.call(l.querySelectorAll('select:not([data-propriete])'), function (s) { return s.value; });
      var notes = {};
      [].forEach.call(l.querySelectorAll('select[data-propriete]'), function (s) { notes[s.getAttribute('data-propriete')] = s.value; });
      var v = trouver(choix);
      if (!v || !v.dispo) { manquant = true; return; }
      var ligne = { id: v.id, quantity: 1 };
      for (var k in notes) { ligne.properties = notes; break; }
      sortie.push(ligne);
    });
    if (alerte) alerte.hidden = !manquant;
    return manquant ? [] : sortie;
  }

  function majPrix() {
    [].forEach.call(LOT.querySelectorAll('.cz-lot__choix'), function (c) {
      var n = parseInt(c.querySelector('input').value, 10);
      /* remise en centimes, la même que la remise automatique Shopify du palier :
         le prix affiché tombe pile sur le total du panier (3 = 71,99 · 4 = 86,99) */
      var r = Math.round((parseInt(c.getAttribute('data-remise'), 10) || 0) * (deviseClient === 'EUR' ? 1 : taux));
      var net = base * n - r;
      /* ensemble seul (pas de remise) : barré au prix « comparé à » (49,99) ; lot (remise) : barré au vrai prix (39,99 × n),
         pour que « Économisez » = ce que le lot fait vraiment gagner (2+1 : 39,99 · 4 : 59,97). */
      var barre = (r > 0 ? base : plein1) * n;
      var p = c.querySelector('.cz-lot__prix');  if (p) p.textContent = sous(net);
      var b = c.querySelector('.cz-lot__barre'); if (b) b.textContent = barre > net ? sous(barre) : '';
      var e = c.querySelector('.cz-lot__badge');
      if (e) { var eco = barre - net; if (eco > 0) { e.textContent = (LOT.getAttribute('data-mot-eco') || 'Économisez') + ' ' + sous(eco);   /* « ÉCONOMISEZ 35,88 € » chez eux, relevé le 23/09/2026 : le mot en entier */ e.hidden = false; } else e.hidden = true; }
      c.setAttribute('data-eco', barre - net);
    });
    majBilan();
  }

  function majBilan() {}

  /* ── menu Couleur fait maison (10/10/2026) ─────────────────────────────── */
  /* Le bouton fermé, la liste et la coche suivent toujours le vrai <select> caché. */
  function majCouleur(menu) {
    var hote = menu.parentNode, rang = menu.selectedIndex;
    var bouton = hote.querySelector('.cz-lot__couleur-bouton');
    if (!bouton) return;
    var img = bouton.querySelector('.cz-lot__vignette');
    if (img && vignettes[rang]) img.src = vignettes[rang];
    [].forEach.call(hote.querySelectorAll('.cz-lot__couleur-noms > span'), function (s, k) { s.classList.toggle('est-choisi', k === rang); });
    [].forEach.call(hote.querySelectorAll('.cz-lot__couleur-choix'), function (b, k) { b.setAttribute('aria-selected', k === rang ? 'true' : 'false'); });
    bouton.setAttribute('aria-label', menu.getAttribute('aria-label') + ', ' + menu.value);
  }
  var ouvert = null;                     /* le menu Couleur ouvert en ce moment, s'il y en a un */
  function fermerCouleur(rendreLaMain) {
    if (!ouvert) return;
    var bouton = ouvert.bouton;
    ouvert.liste.hidden = true; bouton.setAttribute('aria-expanded', 'false'); ouvert = null;
    if (rendreLaMain) bouton.focus();
  }
  function ouvrirCouleur(bouton) {
    fermerCouleur();
    var liste = bouton.parentNode.querySelector('.cz-lot__couleur-liste');
    if (!liste) return;
    liste.hidden = false; bouton.setAttribute('aria-expanded', 'true');
    ouvert = { bouton: bouton, liste: liste };
    var choisi = liste.querySelector('[aria-selected="true"]') || liste.querySelector('.cz-lot__couleur-choix');
    if (choisi) try { choisi.focus({ preventScroll: true }); } catch (e) { choisi.focus(); }
  }
  LOT.addEventListener('click', function (e) {
    var cible = e.target && e.target.closest ? e.target : null;
    if (!cible) return;
    var bouton = cible.closest('.cz-lot__couleur-bouton');
    if (bouton) {
      e.preventDefault();
      if (ouvert && ouvert.bouton === bouton) fermerCouleur(); else ouvrirCouleur(bouton);
      return;
    }
    var choix = cible.closest('.cz-lot__couleur-choix');
    if (!choix) return;
    e.preventDefault();
    var menu = choix.closest('.cz-lot__couleur').querySelector('select');
    var rang = parseInt(choix.getAttribute('data-rang'), 10) || 0;
    if (menu && menu.selectedIndex !== rang) {
      menu.selectedIndex = rang;
      var ev; try { ev = new Event('change', { bubbles: true }); } catch (x) { ev = document.createEvent('Event'); ev.initEvent('change', true, false); }
      menu.dispatchEvent(ev);
    }
    fermerCouleur(true);
  });
  document.addEventListener('click', function (e) {
    if (ouvert && !(e.target && e.target.closest && e.target.closest('.cz-lot__couleur') === ouvert.bouton.parentNode)) fermerCouleur();
  });
  LOT.addEventListener('keydown', function (e) {
    var touche = e.key;
    if (!ouvert) {
      var b = e.target && e.target.closest && e.target.closest('.cz-lot__couleur-bouton');
      if (b && (touche === 'ArrowDown' || touche === 'ArrowUp')) { e.preventDefault(); ouvrirCouleur(b); }
      return;
    }
    var choix = [].slice.call(ouvert.liste.querySelectorAll('.cz-lot__couleur-choix'));
    var ici = choix.indexOf(document.activeElement);
    if (touche === 'Escape' || touche === 'Esc') { e.preventDefault(); fermerCouleur(true); }
    else if (touche === 'Tab') fermerCouleur();
    else if (touche === 'ArrowDown') { e.preventDefault(); choix[Math.min(choix.length - 1, ici + 1)].focus(); }
    else if (touche === 'ArrowUp') { e.preventDefault(); choix[Math.max(0, ici - 1)].focus(); }
    else if (touche === 'Home') { e.preventDefault(); choix[0].focus(); }
    else if (touche === 'End') { e.preventDefault(); choix[choix.length - 1].focus(); }
  });

  LOT.addEventListener('change', function (e) {
    if (e.target.name === 'cz-lot') { fermerCouleur(); if (alerte) alerte.hidden = true; majBilan(); }
    var menu = e.target;
    if (menu.tagName === 'SELECT' && menu.getAttribute('data-option') === '0') majCouleur(menu);
  });

  /* On prend la main sur le CLIC du bouton, pas sur le submit : le tiroir panier
     écoute déjà 'submit' sur document en capture et coupe la propagation. */
  document.addEventListener('click', function (e) {
    var bouton = e.target && e.target.closest && e.target.closest('[type="submit"]');
    if (!bouton) return;
    var formule = bouton.closest('form[action*="/cart/add"]');
    if (!formule) return;
    e.preventDefault(); e.stopPropagation();
    var items = lignes(formule);
    if (!items.length) return;
    bouton.setAttribute('aria-busy', 'true');
    var t = window.hyTiroirPanier;      /* la globale du tiroir ne change JAMAIS de nom */
    /* Le tiroir s'ouvre dès le clic, en « ajout en cours », et se remplit à la réponse de Shopify (05/10/2026). */
    var tout_de_suite = !!(t && t.ouvrirEnAjout);
    if (tout_de_suite) t.ouvrirEnAjout();
    fetch(RACINE + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function () {
      if (t) return tout_de_suite ? t.rafraichir() : t.rafraichir().then(t.ouvrir);
      window.location.href = RACINE + 'cart';
    }).catch(function () { if (t) return t.rafraichir(); }).then(function () {
      if (t && t.finAjout) t.finAjout();
      bouton.removeAttribute('aria-busy');
    });
  }, true);

  dessiner();
  [].forEach.call(LOT.querySelectorAll('.cz-lot__couleur select'), majCouleur);
  majPrix();

  /* Prêt : un toucher fait avant ce moment (mis de côté par cz-bundle.liquid) est rejoué ici (05/10/2026). */
  window.czLotPret = true;
  var enAttente = window.czLotEnAttente; window.czLotEnAttente = null;
  if (enAttente) enAttente.click();
})();
